export default __webpack_public_path__ + "static/media/preetiJoshi.6b9552f4.jpg";